import Joi from '@hapi/joi'

export const estateGTNFactoriesSchemaObject = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group Required`,
        "any.required": `Group Required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate Required`,
        "any.required": `Estate Required`
    }),
    collectionPointID:Joi.number().label("Division").messages({
    }),
    factoryID:Joi.number().invalid(0).required().label("factory").messages({
        "any.invalid": `Factory Required`,
        "any.required": `Factory Required`
    }),
    fieldID:Joi.number().invalid(0).label("Field").messages({
        "any.invalid": `Field Required`,
        "any.required": `Field Required`
    }),
    isActive: Joi.boolean().label("Active"),
    gangName:  Joi.string().required().label("Gang Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Gang Name required`,
        "string.pattern.base": `Please enter valid gang name`,
    }),
    gangCode:  Joi.string().required().label("Gang Code").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Gang code required`,
        "string.pattern.base": `Please enter valid gang code`,
    }),
}














